module.exports = __webpack_public_path__ + "img/regresar.13cfcd11.svg";